import "antd/es/spin/style/css";
import "antd/lib/checkbox/style/index.css";
import "antd/lib/modal/style/css";
import { inject, observer } from "mobx-react";
import queryString from "query-string";
import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "./App.scss";
import ModalAnswer from "./components/modals/answer-modal/answer-modal";
import ModalError from "./components/modals/error-modal/error-modal";
import CongratulationsModal from "./components/modals/congratulations-modal/congratulations-modal";
import FireRemoteService from "./core/services/fire-remote";
import fire from "./fire";
import HomePage from "./pages/home/home";
import QuestionPage from "./pages/question/question";
import WalletPage from "./pages/wallet/wallet";
import WalletFailPage from "./pages/wallet/wallet-fail";
import WalletHomePage from "./pages/wallet/wallet-home";
import WalletSuccessPage from "./pages/wallet/wallet-success";
import AppStore from "./Store";
import TermsConditionsPage from "./pages/terms-conditions/terms-conditions";

@inject("appStore")
@observer
export default class App extends React.Component<{
  appStore: AppStore;
}> {
  componentDidMount() {
    this.checkInitEvent();
  }

  handleGotoWalletHomePage = async () => {
    window.location.href = WalletHomePage.url;
  };

  private checkInitEvent(): void {
    const queryParams: any = queryString.parse(window.location.search); // queryParams = {?init_event: "google_ekim_event"}
    const event: string = queryParams["init_event"]
      ? queryParams["init_event"]
      : queryParams["?init_event"];
    if (event) {
      const eventStrings: string =
        FireRemoteService.getStringValue("INIT_EVENT_VALUES");
      const events: string[] = eventStrings.split("|");
      if (events.includes(event)) {
        console.log(`init event: ${event}`);
        fire.analytics().logEvent(event);
      }
    }
  }

  render() {
    return (
      <div className="h-100 d-flex flex-column justify-content-between">
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path={QuestionPage.url} component={QuestionPage} />
            <Route exact path={WalletPage.url} component={WalletPage} />
            <Route
              exact
              path={WalletSuccessPage.url}
              component={WalletSuccessPage}
            />
            <Route exact path={WalletFailPage.url} component={WalletFailPage} />
            <Route exact path={WalletHomePage.url} component={WalletHomePage} />
            <Route
              exact
              path={TermsConditionsPage.url}
              component={TermsConditionsPage}
            />
            <Route component={() => <Redirect to="/" />} />
          </Switch>
        </BrowserRouter>

        <ModalError
          isVisible={this.props.appStore.isUnknownErrorModalVisible}
          callbackOk={() => {
            this.props.appStore.handleUnknownErrorModalVisibility(false);
          }}
          callbackCancel={() => {
            this.props.appStore.handleUnknownErrorModalVisibility(false);
          }}
        />

        <ModalAnswer
          appStore={this.props.appStore}
          isVisible={this.props.appStore.is1GBWinModalVisible}
          isCorrectAnswer={true}
          isExtra={false}
          callbackOk={() => {
            this.props.appStore.is1GBWinModalVisible = false;
            window.location.href = QuestionPage.url;
            // this event can not be send due to page redirect
            // fire.analytics().logEvent("new_question_button_clicked");
          }}
          callbackCancel={() => {
            this.props.appStore.is1GBWinModalVisible = false;
            window.location.href = QuestionPage.url;
          }}
        />

        <ModalAnswer
          appStore={this.props.appStore}
          isVisible={this.props.appStore.is500MBModalVisible}
          isCorrectAnswer={false}
          isExtra={false}
          callbackOk={() => {
            this.props.appStore.is500MBModalVisible = false;
            window.location.href = QuestionPage.url;
            // fire.analytics().logEvent("new_question_button_clicked");
          }}
          callbackCancel={() => {
            this.props.appStore.is500MBModalVisible = false;
            window.location.href = QuestionPage.url;
          }}
        />

        <ModalAnswer
          appStore={this.props.appStore}
          isVisible={this.props.appStore.isUserWinThreeStampModalVisible}
          isCorrectAnswer={true}
          isExtra={true}
          callbackOk={() => {
            this.props.appStore.isUserWinThreeStampModalVisible = false;
            window.location.href = QuestionPage.url;
            // fire.analytics().logEvent("new_question_button_clicked");
          }}
          callbackCancel={() => {
            this.props.appStore.isUserWinThreeStampModalVisible = false;
            window.location.href = QuestionPage.url;
          }}
        />

        <ModalAnswer
          appStore={this.props.appStore}
          isVisible={
            this.props.appStore.isUserAnsweredWrongThirdQuestionModalVisible
          }
          isCorrectAnswer={false}
          isExtra={true}
          callbackOk={() => {
            this.props.appStore.isUserAnsweredWrongThirdQuestionModalVisible =
              false;
            window.location.href = QuestionPage.url;
            // fire.analytics().logEvent("new_question_button_clicked");
          }}
          callbackCancel={() => {
            this.props.appStore.isUserAnsweredWrongThirdQuestionModalVisible =
              false;
            window.location.href = QuestionPage.url;
          }}
        />

        {/* New Answer Validation Modal */}
        <ModalAnswer
          appStore={this.props.appStore}
          isVisible={this.props.appStore.isAnswerValidationModalVisible}
          isCorrectAnswer={this.props.appStore.isAnswerCorrect}
          isExtra={false}
          showPaymentButton={true}
          callbackOk={() => {
            // Payment will be handled by the QuestionPage component
            // We need to trigger the payment from the question page
            const event = new CustomEvent('triggerCheckTokenBalance');
            window.dispatchEvent(event);
          }}
          callbackCancel={() => {
            this.props.appStore.resetAnswerSelection();
            // window.location.href = QuestionPage.url;
          }}
        />

        {/* Congratulations Modal */}
        <CongratulationsModal
          appStore={this.props.appStore}
          isVisible={this.props.appStore.isCongratulationsModalVisible}
          isCorrect={this.props.appStore.isAnswerCorrect}
          callbackGetNewQuestion={() => {
            // Close modal and get new random question
            this.props.appStore.isCongratulationsModalVisible = false;
            // Trigger getting a new random question
            const event = new CustomEvent('triggerGetRandomQuestion');
            window.dispatchEvent(event);
            this.props.appStore.chosenAnswerIndex = undefined;
            this.props.appStore.answerId = undefined;
            window.location.href = QuestionPage.url;
          }}
        />
      </div>
    );
  }
}
